<p class="text-lg font-semibold mb-xl">
  {{ 'user_form_screen_quick_create_position_title' | transloco }}
</p>

<form [formGroup]="formGroup" class="flex flex-col gap-lg">
  <div class="grid grid-cols-2 gap-lg">
    <div class="col-span-2">
      <div formGroupName="name">
        <lib-dual-lang-input
          [requiredGroup]="true"
          [inputFormControlName]="'name'"
          [id]="'quick_create_position_name'"
          type="text"
          name="name"
          [requiredEn]="false"
          [requiredAr]="false"
          [label]="'positions_form_position_name_label' | transloco"
          [placeholderEn]="
            'positions_form_position_name_placeholder_en' | transloco
          "
          [placeholderAr]="
            'positions_form_position_name_placeholder_ar' | transloco
          " />
      </div>
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="name" />
    </div>

    <div>
      <lib-input
        [inputFormControlName]="'identifier'"
        [id]="'quick_create_position_identifier'"
        type="text"
        name="identifier"
        [label]="'positions_form_position_id_label' | transloco"
        [placeholder]="'positions_form_position_id_placeholder' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="identifier" />
    </div>

    <div>
      <lib-select
        [inputFormControlName]="'legal_entity_id'"
        id="quick_create_position_legal_entity_id"
        name="legal_entity_id"
        [label]="'positions_form_legal_entity_label' | transloco"
        [required]="true"
        [placeholder]="'positions_form_legal_entity_placeholder' | transloco"
        [options]="legalEntity()"
        [selectedKeyValue]="'value'"
        [selectedKeyName]="'label'" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="legal_entity_id" />
    </div>

    <div>
      <lib-paginated-select
        [id]="'quick_create_position_department_id'"
        [inputFormControlName]="'department_id'"
        [name]="'department_id'"
        [required]="true"
        [label]="'positions_form_department_label' | transloco"
        [placeholder]="'positions_form_department_placeholder' | transloco"
        [apiUrl]="departmentApi"
        [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="department_id" />
    </div>

    <div>
      <lib-paginated-select
        [id]="'quick_create_position_job_title_id'"
        [inputFormControlName]="'job_title_id'"
        [name]="'job_title_id'"
        [required]="true"
        [label]="'positions_form_job_title_label' | transloco"
        [placeholder]="'positions_form_job_title_placeholder' | transloco"
        [apiUrl]="jobTitleApi"
        [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="job_title_id" />
    </div>

    <div>
      <lib-paginated-select
        [id]="'quick_create_position_reports_to_position_id'"
        [inputFormControlName]="'reports_to_position_id'"
        [name]="'reports_to_position_id'"
        [label]="'positions_form_reports_to_position_label' | transloco"
        [placeholder]="
          'positions_form_reports_to_position_placeholder' | transloco
        "
        [apiUrl]="reportingPositionApi"
        [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="reports_to_position_id" />
    </div>

    <div>
      <lib-input
        [inputFormControlName]="'fte'"
        [id]="'quick_create_position_fte'"
        type="number"
        name="fte"
        [label]="'positions_form_fte_label' | transloco"
        [placeholder]="'positions_form_fte_placeholder' | transloco"
        [acceptDecimal]="true"
        [maxDecimalPlaces]="2"
        [min]="0"
        [max]="1" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="fte" />
    </div>

    <div>
      <lib-date-picker
        [inputFormControlName]="'effective_from'"
        [id]="'quick_create_position_effective_from'"
        [name]="'effective_from'"
        [placeholder]="
          'positions_form_effective_from_placeholder' | transloco
        "
        [label]="'positions_form_effective_from_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="effective_from" />
    </div>

    <div>
      <lib-date-picker
        [inputFormControlName]="'effective_to'"
        [id]="'quick_create_position_effective_to'"
        [name]="'effective_to'"
        [placeholder]="'positions_form_effective_to_placeholder' | transloco"
        [label]="'positions_form_effective_to_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="effective_to" />
    </div>
  </div>

  <div class="flex gap-md justify-end mt-lg">
    <button
      type="button"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm px-xl rounded-md text-base cursor-pointer"
      (click)="cancel()">
      {{ 'quick_create_cancel_button_label' | transloco }}
    </button>
    <button
      type="button"
      [class.opacity-30]="isLoading()"
      [disabled]="isLoading()"
      class="bg-primary-500 py-sm px-xl rounded-md text-white text-base cursor-pointer"
      (click)="submit()">
      {{ 'quick_create_save_button_label' | transloco }}
    </button>
  </div>
</form>
